import { render, staticRenderFns } from "./TextAdvancedProperties.vue?vue&type=template&id=59a656e5&scoped=true"
import script from "./TextAdvancedProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextAdvancedProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextAdvancedProperties.vue?vue&type=style&index=0&id=59a656e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a656e5",
  null
  
)

export default component.exports